"use client"

import { KeyboardOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `KeyboardOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const KeyboardOffIcon = component(Icon)({ as: KeyboardOff })
